module.exports = __webpack_public_path__ + "static/media/3dinamo_mn.fb86bb1e.png";